import Carousel from 'global/carousel.src';
import startFreeTrialForm from 'global/free-trial-form2.src';

[].forEach.call(document.querySelectorAll('.carousel'), (item) => {
    const c = new Carousel(item);
});
[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    startFreeTrialForm.init(form);
});

/* ------------------------------------*\
    AUTOFUNNEL TRAPEZOIDS GENERATOR
\*------------------------------------*/

const autofunnel = document.querySelector('.autofunnel');
const funnel = autofunnel.querySelector('.funnel');
const funnelBottom = 340;
const funnelTop = 490;
let tangens;
let dir = document.querySelector('html').getAttribute('dir');

const trapezoids = [].map.call(funnel.querySelectorAll('.trapezoid'), (div) => (div));
const itemsCount = trapezoids.length;

let width = funnelBottom;

const mq = window.matchMedia('(max-width: 767px)');

function rebuildFunnel() {
    tangens = (funnelTop - funnelBottom) / 2 / (document.querySelector('.funnel-wrapper').offsetHeight);
    const deg = Math.atan2((funnelTop - funnelBottom) / 2, (document.querySelector('.funnel-wrapper').offsetHeight)) * 180 / Math.PI;

    if (!mq.matches) {
        width = funnelBottom;
        for (let i = itemsCount - 1; i >= 0; i -= 1) {
            document.querySelector(`.funnel [data-funnel="${i + 1}"] .heading`).style.width = `${width}px`;

            width += (2 * tangens * trapezoids[i].offsetHeight);
            trapezoids[i].style.width = `${width}px`;
            if (dir === 'rtl') {
                trapezoids[i].style.marginRight = `${(funnelTop - width) / 2}px`;
            } else {
                trapezoids[i].style.marginLeft = `${(funnelTop - width) / 2}px`;
            }
            trapezoids[i].querySelector('.left').style.transform = `skewX(${deg}deg)`;
            trapezoids[i].querySelector('.right').style.transform = `skewX(-${deg}deg)`;

            width += (2 * tangens * 3);
        }
    } else {
        for (let i = itemsCount - 1; i >= 0; i -= 1) {
            trapezoids[i].style.width = '100%';
            if (dir === 'rtl') {
                trapezoids[i].style.marginRight = '0';
            } else {
                trapezoids[i].style.marginLeft = '0';
            }
            trapezoids[i].querySelector('.left').style.transform = `skewX(2deg)`;
            trapezoids[i].querySelector('.right').style.transform = `skewX(-2deg)`;
        }
    }
}
rebuildFunnel();
window.addEventListener('resize', rebuildFunnel);
window.addEventListener('load', rebuildFunnel);
